/**
 * Canonical browser URL paths for the application.
 * Use these constants for router.navigate() and menu definitions.
 */
export const AppRoutes = {
    dashboard: '/dashboard',
    reports: '/reports',
    reportsTimesheet: '/reports/timesheet-report',
    reportsAttendance: '/reports/attendance-report',
    reportsProductivityBar: '/reports/productivity-bar-report',
    reportsTimeOff: '/reports/time-off-report',
    reportsProjectAllocation: '/reports/project-allocation',
    timesheet: '/timesheet',
    projects: '/projects',
    projectsAdd: '/projects/add',
    projectsEdit: '/projects/edit',
    projectsDetails: '/projects/details',
    projectsAddInternal: '/projects/add-internal',
    projectsEditInternal: '/projects/edit-internal',
    clients: '/clients',
    clientsCreateOrEdit: '/clients/create-or-edit',
    clientsDetails: '/clients/details',
    clientsDashboard: '/clients/dashboard',
    clientsViewDetails: '/clients/view-selected',
    clientsPortalTeam: '/clients/portal/team',
    clientsPortalTask: '/clients/portal/task',
    clientsPortalWorkSchedule: '/clients/portal/work-schedule',
    clientsPortalInvoices: '/clients/portal/invoices',
    clientsPortalConsult: '/clients/portal/consult-us',
    clientsPortalTimesheet: '/clients/portal/timesheet-details',
    productsAndServices: '/products-and-services',
    productsAndServicesCreateOrEdit: '/products-and-services/create-or-edit',
    leaves: '/leaves',
    leavesAddAwayTime: '/leaves/add-away-time',
    activitiesRealTimeTracking: '/activities/real-time-tracking',
    activitiesTimeAndAttendance: '/activities/time-and-attendance',
    activitiesAppsAndWebsites: '/activities/apps-and-websites',
    activitiesScreenshots: '/activities/screenshots',
    activitiesLiveScreenshots: '/activities/live-screenshots',
    timeTracking: '/time-tracking',
    timeTrackingAgent: '/time-tracking/agent',
    masters: '/masters',
    appCategory: '/app-category',
    invoices: '/invoices',
    invoicesCreateOrEdit: '/invoices/create-or-edit',
    quickStart: '/quick-start',
    quickStartInviteUser: '/quick-start-invite-user',
    inviteUser: '/invite-user',
    demo: '/demo',
    notifications: '/notifications',
    companyProfile: '/company-profile',
    myProfile: '/my-profile',
    helpSection: '/help-section',
    helpSectionContent: '/help-section/content',
    tenantSettings: '/tenant-settings',
    admin: {
        hostDashboard: '/admin/host-dashboard',
        tenants: '/admin/tenants',
        trialTenant: '/admin/trial-tenant',
        editions: '/admin/editions',
        users: '/admin/users',
        inviteUser: '/admin/invite-user',
        usersInviteUser: '/admin/users/invite-user',
        roles: '/admin/roles',
        languages: '/admin/languages',
        auditLogs: '/admin/audit-logs',
        maintenance: '/admin/maintenance',
        hostSettings: '/admin/host-settings',
        organizationUnits: '/admin/organization-units',
        subscriptionManagement: '/admin/subscription-management',
        invoice: '/admin/invoice',
        uiCustomization: '/admin/ui-customization',
        webhookSubscriptions: '/admin/webhook-subscriptions',
        webhookSubscriptionsDetail: '/admin/webhook-subscriptions-detail',
        webhookEventDetail: '/admin/webhook-event-detail',
        dynamicProperty: '/admin/dynamic-property',
        dynamicEntityProperty: '/admin/dynamic-entity-property',
        inviteUserprofile: '/admin/invite-userprofile',
        memberAllocation: '/admin/member-allocation',
        memberAllocationDetail: '/admin/member-allocation/detail',
        superAdmin: '/admin/super-admin',
        exploreUser: '/admin/explore-user',
        install: '/admin/install',
        demoUiComponents: '/admin/demo-ui-components',
        attendanceReportDistribution: '/admin/attendance-report-distribution',
        attendanceReportDistributionCreate: '/admin/attendance-report-distribution/create',
        attendanceReportDistributionEdit: '/admin/attendance-report-distribution/edit',
    },
} as const;
